import { render, staticRenderFns } from "./CollapseSectionLayout.vue?vue&type=template&id=192afd74&scoped=true&"
import script from "./CollapseSectionLayout.vue?vue&type=script&lang=js&"
export * from "./CollapseSectionLayout.vue?vue&type=script&lang=js&"
import style0 from "./CollapseSectionLayout.vue?vue&type=style&index=0&id=192afd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192afd74",
  null
  
)

export default component.exports